import { connect } from 'react-redux'
import EveServerManager from './component'
import { actions, attributes, tokenServices } from '../../../../imports'

function mapStateToProps() {
    return {
        serviceDomains: attributes.serviceDomains,
        tokenServices: {
            testing: tokenServices.test,
            production: tokenServices.production,
        },
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setActiveServer: (serverName) => {
            dispatch(actions.setActiveServer(serverName))
        },
        setServerList: (serverList) => {
            dispatch(actions.setServerList(serverList))
        },
        setEnabledServers: (enabledServers) => {
            dispatch(actions.setEnabledServers(enabledServers))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EveServerManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/EveServerManager/index.js